var _rect, _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadStartIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#FFEFEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1385 24.224L7.93663 19.0157C7.59083 18.6709 7.31647 18.2612 7.12926 17.8102C6.94206 17.3591 6.8457 16.8756 6.8457 16.3872C6.8457 15.8989 6.94206 15.4153 7.12926 14.9643C7.31647 14.5132 7.59083 14.1036 7.93663 13.7587L11.7561 9.93283C12.9992 8.68985 14.4811 7.71151 16.1126 7.05682C17.744 6.40214 19.4912 6.08466 21.2486 6.12355C22.4529 6.15086 23.6019 6.63447 24.4633 7.47659C25.3247 8.3187 25.8341 9.45648 25.8886 10.6599V10.7303C25.9703 12.5368 25.6747 14.3405 25.0206 16.0265C24.3665 17.7124 23.3683 19.2435 22.0896 20.5223L18.3878 24.224C17.6917 24.9201 16.7476 25.3111 15.7632 25.3111C14.7788 25.3111 13.8347 24.9201 13.1385 24.224Z",
    fill: "#FF5630"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1799 12.5094L9.7879 11.904C8.89859 11.7906 7.99508 11.8894 7.15126 12.1922C6.30743 12.495 5.54725 12.9932 4.93286 13.6461C3.58246 14.9517 3.64134 16.8461 5.04422 17.2301L6.34086 17.5782C6.46419 17.6135 6.59419 17.6189 6.71999 17.5937C6.84578 17.5685 6.96373 17.5136 7.06397 17.4335C7.16421 17.3535 7.24383 17.2506 7.29618 17.1335C7.34852 17.0163 7.37208 16.8884 7.36486 16.7603C7.3548 15.9644 7.51104 15.1752 7.82359 14.4432C8.13614 13.7112 8.5981 13.0526 9.1799 12.5094Z",
    fill: "#FFBC33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2533 22.3655L19.6441 22.9748C19.1016 23.5565 18.444 24.0188 17.7129 24.3322C16.9819 24.6455 16.1936 24.8031 15.3983 24.7949C15.2701 24.7874 15.142 24.8108 15.0247 24.863C14.9075 24.9153 14.8044 24.9949 14.7243 25.0952C14.6442 25.1955 14.5893 25.3136 14.5642 25.4396C14.5392 25.5655 14.5447 25.6956 14.5804 25.8189L14.9298 27.1156C15.3074 28.5236 17.2057 28.5786 18.5138 27.2269C19.1677 26.612 19.6663 25.8507 19.9687 25.0056C20.2711 24.1605 20.3687 23.2556 20.2533 22.3655Z",
    fill: "#FFBC33"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2934 15.6648C20.8416 15.6648 22.0966 14.4097 22.0966 12.8616C22.0966 11.3134 20.8416 10.0583 19.2934 10.0583C17.7453 10.0583 16.4902 11.3134 16.4902 12.8616C16.4902 14.4097 17.7453 15.6648 19.2934 15.6648Z",
    fill: "#FFBC33"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    d: "M8.09375 25.1968C8.31974 23.9223 8.78722 22.7028 9.47103 21.6038C9.51583 21.5296 9.60799 21.4976 9.64895 21.5398L11.7469 23.6365C11.7891 23.6787 11.7558 23.7709 11.6829 23.8144C10.5857 24.5 9.36738 24.9692 8.09375 25.1968Z",
    fill: "url(#paint0_linear_5204:29017)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    d: "M6.98438 24.0872C7.21146 22.8122 7.68072 21.5926 8.36678 20.4942C8.4103 20.4213 8.50246 20.388 8.5447 20.4302L10.6413 22.5281C10.6836 22.5691 10.6516 22.6561 10.5773 22.7061C9.47865 23.3912 8.25911 23.86 6.98438 24.0872Z",
    fill: "url(#paint1_linear_5204:29017)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M7.52477 24.6285C7.47625 23.2035 7.76528 21.7873 8.36829 20.4953C8.37707 20.4768 8.39016 20.4607 8.40648 20.4482C8.42279 20.4358 8.44185 20.4275 8.46204 20.424C8.48224 20.4205 8.50299 20.4219 8.52253 20.4281C8.54208 20.4342 8.55986 20.445 8.57437 20.4595L11.6937 23.5801C11.7079 23.5947 11.7185 23.6123 11.7245 23.6318C11.7305 23.6512 11.7318 23.6717 11.7283 23.6917C11.7248 23.7117 11.7166 23.7306 11.7044 23.7468C11.6921 23.763 11.6762 23.7761 11.6579 23.7849C10.3659 24.3879 8.94971 24.677 7.52477 24.6285Z",
    fill: "#FF5630"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5204:29017",
    x1: 53.623,
    y1: 96.272,
    x2: 62.6224,
    y2: 96.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5204:29017",
    x1: 48.0578,
    y1: 95.1577,
    x2: 57.0708,
    y2: 95.1577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA300"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadStartIcon);
export default __webpack_public_path__ + "static/media/headStartIcon.03b059aa.svg";
export { ForwardRef as ReactComponent };